import { t } from 'ember-intl';
import { BreadcrumbsItem } from 'core/components';

<template>
  <BreadcrumbsItem
    @icon="users"
    @route="cloud.access-control.invites.list"
    @text={{t
      "components.page.access-control.title"
      resourceName=(t "components.page.access-control.invites.list.title")
      htmlSafe=true
    }}
    data-test-access-control-invites-list-breadcrumb
  />

  {{outlet}}
</template>
